import { t } from "i18next";
import { useReaderHintsSettings } from "../../hooks/useReaderHintsSettings";
import { SettingsToggle } from "./SettingsToggle";

export function ReaderHintsToggle() {
  const { showReaderHints, toggleShowReaderHints } = useReaderHintsSettings();

  return (
    <SettingsToggle
      isDisabled={false}
      isChecked={showReaderHints}
      onChange={toggleShowReaderHints}
      title={t("screens.reader.settingsMenu.showReaderHints")}
      flexProps={{ borderTopRadius: "0px" }}
    />
  );
}
